import { awsApiInstance } from '../api/aws-api';
import useAuth from '../hooks/auth-hooks';

import { ITaxCardGroupTerminal, ITaxCardGroupTerminalResponse } from '../models/terminal.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts a list of taxes linked to an individual card group/terminal/customer.
 * 
 * @param {ITaxCardGroupTerminal} tCgT the card group id, terminal id, and tax id list
 */
const PostCardGroupTerminalTax = async ( tCgT: ITaxCardGroupTerminal ): Promise<ITaxCardGroupTerminalResponse> => {
  try {
    const { userId } = useAuth()!; 

    const modelData = {
      wpID: userId,
      cardGroupId: tCgT.cardGroupID,
      terminalId: tCgT.terminalID,
      taxArray: tCgT.taxIdArray
    };

    const { data } = await awsApiInstance.post(`/card-group/${tCgT.cardGroupID}/tax`, modelData);

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error updating tax data');
    throw(error);
  }
}

export default PostCardGroupTerminalTax;